import clsx from 'clsx';
import { motion } from 'framer-motion';

const NewBadgeAnimated = ({ tag }: { tag: string }) => {
    return (
        <motion.div
            className={clsx(
                'items-center justify-center w-fit py-[4px] flex flex-col',
                'rounded-full',
                'relative overflow-hidden',
                'mx-2',
                // THÊM: Đổ bóng màu cam vàng để tạo cảm giác phát sáng (Neon Glow)
                'shadow-[0_0_10px_rgba(245,158,11,0.6)]'
            )}
            style={{
                // GRADIENT MỚI: Rực rỡ hơn (Vivid)
                // Từ Vàng Rực (Amber-400) -> Cam Đậm (Orange-600) -> Vàng Rực
                background:
                    'linear-gradient(90deg, #FBBF24 0%, #EA580C 50%, #FBBF24 100%)',
                backgroundSize: '200% 100%',
            }}
            animate={{
                backgroundPosition: ['0% 0%', '-200% 0%'],
            }}
            transition={{
                duration: 3,
                ease: 'linear',
                repeat: Infinity,
            }}
        >
            {/* Lớp bên trong: Trong suốt (không có bg) */}
            <div
                className={clsx(
                    'rounded-full px-2  flex items-center justify-center w-full h-full'
                )}
            >
                {/* THÊM: drop-shadow-sm để chữ trắng tách biệt khỏi nền cam, dễ đọc hơn */}
                <span className="text-white text-[9px] font-extrabold tracking-widest uppercase leading-none  drop-shadow-md">
                    {tag}
                </span>
            </div>
        </motion.div>
    );
};

export default NewBadgeAnimated;
